// Maps a backend error `code` to panel-owned ES copy for the marks clear. Every cause falls open to
// the generic: the delivered `DELETE` has no failure that changes what the agent must DO. We never
// render the envelope's `message`/`detail` (untrusted backend string), nor the code itself.
// Same shape as extendCustodyError and enableDeliveryError — a code in, panel copy out. The
// `persistent` flag the three of them used to carry is gone with ADR 0021: the floating notice stays
// up until the agent dismisses it, whatever the cause.

// Intentionally EMPTY. The panel asked for a `409 box_marks_not_clearable` — «the incident already
// exists, stop and escalate to Mantenimiento» — and backend declined it in favour of strict parity
// with `admin`, which never refuses a clear (CBX-11149). The banner withholding its action past the
// cap is the whole defence. If that guard rail ever lands, its copy goes here and nothing else in
// this file changes.
// TODO: i18n — copy en ES hasta Fase 1.
const SPECIFIC: Record<string, string> = {};

export function boxMarksError(code: string | null): string {
  // Own-property only: the code is wire data, and a bare lookup also resolves inherited names, so a
  // `constructor` code would come back truthy carrying no readable message. Still load-bearing with
  // SPECIFIC empty — `{}['constructor']` is Object.prototype's, not absent.
  const key = code?.toLowerCase() ?? '';
  const message = Object.hasOwn(SPECIFIC, key) ? SPECIFIC[key] : undefined;
  return message ?? 'No se han podido limpiar las marcas.'; // TODO: i18n
}
